// extracted by mini-css-extract-plugin
export default {"container":"yiGKKiU8QF_zQPrecymF","body":"ynYw7cnQOJOAn9Rva4DD","error":"rsbm1ft89Lp19sJZ3s7j","alternatives":"VlywGOicWPuHqnALpnqb"};